import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import CustomNavbar from "../../../components/CustomNavbar";
import SibebarDescriptorsProfiles from "../../../components/descriptorsProfiles/SibebarDescriptorsProfiles";
import {
  getAreas,
  saveArea,
  editArea,
  deleteArea,
} from "../../../redux/descriptorsProfiles/areas/actions";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import messages from "../../../redux/messages";

const schema = Yup.object().shape({
  descripcion: Yup.string().ensure().required("**Campo requerido"),
});

const Area = (props) => {
  //* States
  const [show, setShow] = useState(true);
  const [showFormModal, setShowFormModal] = useState(false);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [filter, setFilter] = useState("");
  const [editItem, setEditItem] = useState({});
  const [validated, setValidated] = useState(false);
  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "descripcion",
    desc: "Descripción",
  });
  //* Redux
  const { loaderAreas, saveLoaderArea, areas, areasFaild, formAreaFaild } =
    useSelector((store) => store.areasDescriptoresPerfiles);
  //* variables
  const dispatch = useDispatch();
  const pages = Math.ceil((areas ? areas.count : 0) / limit);
  const columns = [
    {
      Header: "Descripción",
      accessor: "descripcion",
    },
    {
      id: "fecha_creacion",
      Header: "Fecha de creación",
      Filter: "",
      Cell: (value) =>
        moment(value.row.original.fecha_creacion).format("DD/MM/YYYY"),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];
  const filters = [
    { id: "descripcion", desc: "Descripción" },
    { id: "fecha_creacion", desc: "Fecha de creación" },
  ];
  //* Method
  const _getAreas = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getAreas({
        offset: offs,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter:
          tipoBusqueda.id === "fecha_creacion"
            ? filt !== ""
              ? !isNaN(filt)
                ? filt
                : `${filt.charAt(6)}${filt.charAt(7)}${filt.charAt(
                    8
                  )}${filt.charAt(9)}-${filt.charAt(3)}${filt.charAt(
                    4
                  )}-${filt.charAt(0)}${filt.charAt(1)}`
              : filt
            : filt,
      })
    );

  useEffect(() => {
    _getAreas();
  }, []);

  const onAdd = () => {
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getAreas(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = (req) => {
    //console.log(req);
    if (!edit) {
      dispatch(saveArea(req, setShowFormModal));
    } else {
      req.id = editItem.id;
      dispatch(editArea(req, index, setShowFormModal));
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getAreas(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteArea(id, index));
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SibebarDescriptorsProfiles show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">Áreas</h5>
            <Form onSubmit={onSearch}>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col>
                  <h6>
                    <b>Busqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    type="search"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill mr-1"
                      onClick={() => seeAll()}
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="ml-3 mr-3">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Form.Row>
            </Form>
          </div>
          {areasFaild && (
            <Alert variant="danger" className="my-4">
              {areasFaild}
            </Alert>
          )}
          {loaderAreas ? (
            <div className="d-flex justify-content-center mt-4">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : areas && areas.data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable columns={columns} data={areas.data} />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={areas.count}
                pages={pages}
                pagFunc={_getAreas}
              />
            </>
          ) : (
            <Alert variant="info" className="my-4">
              Sin registros que mostrar.
            </Alert>
          )}
        </Container>
      </div>
      <Modal show={showFormModal} onHide={() => setShowFormModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            descripcion: edit ? editItem.descripcion : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            //setFieldValue,
            values,
            touched,
            //isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="ft-modal-title">
                  {edit ? "Editar Áreas" : "Agregar Áreas"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {formAreaFaild && typeof formAreaFaild !== "object" ? (
                  <Alert variant="danger" className="mt-4 mb-2">
                    {formAreaFaild}
                  </Alert>
                ) : null}
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Descripción
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      name="descripcion"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.descripcion}
                      placeholder="Descripción"
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.descripcion && !!errors.descripcion}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.descripcion}
                    </Form.Control.Feedback>
                    {formAreaFaild &&
                    typeof formAreaFaild === "object" &&
                    formAreaFaild.descripcion ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formAreaFaild.descripcion.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Col>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowFormModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoaderArea}
                  variant="primary"
                  type="submit"
                >
                  {saveLoaderArea && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default Area;
